/**
 * @param {string | null | undefined} raw
 * @returns {string | null}
 */
export function safeReturnPath(raw) {
  if (!raw || typeof raw !== 'string') return null;
  let decoded = raw;
  try {
    decoded = decodeURIComponent(raw);
  } catch {
    return null;
  }
  if (!decoded.startsWith('/') || decoded.startsWith('//') || decoded.includes('://')) return null;
  if (decoded.startsWith('/login')) return null;
  return decoded;
}

export function loginPathWithReturn(relativePathWithQuery) {
  const path = relativePathWithQuery || '/dashboard';
  if (path.startsWith('/login')) return '/login';
  return `/login?returnUrl=${encodeURIComponent(path)}`;
}
